import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const FinancialPOA = () => {
  const {
    register,
    watch
  } = useFormContext();
  const [primaryAttorneys, setPrimaryAttorneys] = useState([{
    id: 1
  }]);
  const [alternateAttorneys, setAlternateAttorneys] = useState([{
    id: 1
  }]);
  const addPrimaryAttorney = () => {
    const newId = primaryAttorneys.length > 0 ? Math.max(...primaryAttorneys.map(a => a.id)) + 1 : 1;
    setPrimaryAttorneys([...primaryAttorneys, {
      id: newId
    }]);
  };
  const removePrimaryAttorney = (id: number) => {
    setPrimaryAttorneys(primaryAttorneys.filter(a => a.id !== id));
  };
  const addAlternateAttorney = () => {
    const newId = alternateAttorneys.length > 0 ? Math.max(...alternateAttorneys.map(a => a.id)) + 1 : 1;
    setAlternateAttorneys([...alternateAttorneys, {
      id: newId
    }]);
  };
  const removeAlternateAttorney = (id: number) => {
    setAlternateAttorneys(alternateAttorneys.filter(a => a.id !== id));
  };
  return <div className="space-y-8" data-id="element-692" data-mp="2uoh1nk1uvfxu">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-693" data-mp="2uoqvjiq0u78t">
        <p className="text-slate-700" data-id="element-694" data-mp="2px8r2koshoj3">
          A Power of Attorney for Property gives someone else the legal
          authority to make decisions about your finances and property if you
          become unable to make these decisions yourself.
        </p>
      </div>

      {/* Primary Attorneys */}
      <div className="space-y-4" data-id="element-695" data-mp="3dnux66f8gyqg">
        <div className="flex justify-between items-center" data-id="element-696" data-mp="3dmtaf4ouunsw">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-697" data-mp="39l83s12wz5r5">
            Primary Attorney(s) for Property
          </h3>
          <button type="button" onClick={addPrimaryAttorney} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-698" data-mp="1j9lmzy37leha">
            <PlusIcon size={16} className="mr-1" data-id="element-699" data-mp="3edryuzk8k5rm" />
            Add Attorney
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-700" data-mp="3jc393beg0iad">
          <p className="text-sm text-blue-800" data-id="element-701" data-mp="3o9v2yayneeh7">
            You may name one or more Primary Attorneys. If you name multiple
            attorneys, you will need to specify whether they should act jointly
            (together) or independently (separately).
          </p>
        </div>

        {primaryAttorneys.map((attorney, index) => <div key={attorney.id} className="p-4 bg-slate-50 rounded-md" data-id="element-702" data-mp="62otf16s86sj" data-mpi={index}>
            <div className="flex justify-between items-center mb-3" data-id="element-703" data-mp="aw9s6vg794ss">
              <h4 className="font-medium" data-id="element-704" data-mp="fv4fa9l79fip">Primary Attorney {index + 1}</h4>
              {primaryAttorneys.length > 1 && <button type="button" onClick={() => removePrimaryAttorney(attorney.id)} className="text-red-500 hover:text-red-700" data-id="element-705" data-mp="kvinpsqpqrh9">
                  <TrashIcon size={16} data-id="element-706" data-mp="29ewitwr4xtew" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-707" data-mp="25aos5u14a3e1">
              <div data-id="element-708" data-mp="20dyd9a11tdu7">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-709" data-mp="20df5un90y7uf">
                  Name
                  <span className="text-red-500 ml-1" data-id="element-710" data-mp="1vfdbv7a28o46">*</span>
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter attorney's name" {...register(`financialPOA.primary.${index}.name`)} data-id="element-711" data-mp="2t0j4mahixpxr" />
              </div>
              <div data-id="element-712" data-mp="2eatye0ukqvqm">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-713" data-mp="3brsgurioist1">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Spouse, Child, Friend" {...register(`financialPOA.primary.${index}.relationship`)} data-id="element-714" data-mp="370amwnf2pshk" />
              </div>
              <div data-id="element-715" data-mp="2mk7ra2vxpn7k">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-716" data-mp="2mjfyeztq23kz">
                  Phone Number
                </label>
                <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register(`financialPOA.primary.${index}.phone`)} data-id="element-717" data-mp="3aaby0j4f632s" />
              </div>
            </div>
            <div className="mt-4" data-id="element-718" data-mp="3t8xwdq8jxg30">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-719" data-mp="3t7wdx0p7hrb9">
                Address
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter attorney's address" {...register(`financialPOA.primary.${index}.address`)} data-id="element-720" data-mp="1vbguk6pwetu" />
            </div>
          </div>)}

        {/* Joint or Independent - only show if multiple primary attorneys */}
        {primaryAttorneys.length > 1 && <div className="p-4 bg-amber-50 rounded-md border border-amber-200" data-id="element-721" data-mp="13m36qxnzq56p">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-722" data-mp="yni5qw0wzhh7">
              Should your primary attorneys act jointly or independently?
            </label>
            <div className="space-y-2" data-id="element-723" data-mp="17n50x031vr1t">
              <label className="flex items-start" data-id="element-724" data-mp="17mdcqabs8vlk">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="jointly" {...register('financialPOA.primaryActing')} data-id="element-725" data-mp="2o1eklgwckrmb" />
                <span className="ml-2 block" data-id="element-726" data-mp="1gnued7ykgop5">
                  <span className="font-medium" data-id="element-727" data-mp="1gr8gcf3bivw2">Jointly</span>
                  <span className="text-sm text-slate-600 block" data-id="element-728" data-mp="1lmnqox24a9nq">
                    All attorneys must agree and act together on all decisions.
                  </span>
                </span>
              </label>
              <label className="flex items-start" data-id="element-729" data-mp="1uo57yir9ghe0">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="independently" {...register('financialPOA.primaryActing')} data-id="element-730" data-mp="xyxttvsz1ak4" />
                <span className="ml-2 block" data-id="element-731" data-mp="16xjbzpuj6nkd">
                  <span className="font-medium" data-id="element-732" data-mp="1bpj5azg3ii7z">
                    Independently (Jointly and Severally)
                  </span>
                  <span className="text-sm text-slate-600 block" data-id="element-733" data-mp="e9dkmk8z20bk">
                    Any one attorney can act alone without the others.
                  </span>
                </span>
              </label>
            </div>
          </div>}
      </div>

      {/* Alternate Attorneys */}
      <div className="space-y-4" data-id="element-734" data-mp="6rxmykpxrc1d">
        <div className="flex justify-between items-center" data-id="element-735" data-mp="6rp66hqozmkw">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-736" data-mp="1r1h41m0xftb">
            Alternate Attorney(s) for Property
          </h3>
          <button type="button" onClick={addAlternateAttorney} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-737" data-mp="3txyamj4tqk3t">
            <PlusIcon size={16} className="mr-1" data-id="element-738" data-mp="3k4hev9l4muxi" />
            Add Attorney
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-739" data-mp="3f4mod759k7cz">
          <p className="text-sm text-blue-800" data-id="element-740" data-mp="3a9ftmotz2d07">
            Alternate attorneys will act if your primary attorney(s) are unable
            or unwilling to act. You may name one or more alternates.
          </p>
        </div>

        {alternateAttorneys.map((attorney, index) => <div key={attorney.id} className="p-4 bg-slate-50 rounded-md" data-id="element-741" data-mp="szjjtemr252z" data-mpi={index}>
            <div className="flex justify-between items-center mb-3" data-id="element-742" data-mp="xxurpjthi5ik">
              <h4 className="font-medium" data-id="element-743" data-mp="jxk36nfnd30k">Alternate Attorney {index + 1}</h4>
              {alternateAttorneys.length > 1 && <button type="button" onClick={() => removeAlternateAttorney(attorney.id)} className="text-red-500 hover:text-red-700" data-id="element-744" data-mp="nydr3gt3ahtg">
                  <TrashIcon size={16} data-id="element-745" data-mp="eyqrn0jx7m31" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-746" data-mp="acdhth20b76">
              <div data-id="element-747" data-mp="58nnc47cmlpe">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-748" data-mp="584b944dqrja">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate attorney's name" {...register(`financialPOA.alternate.${index}.name`)} data-id="element-749" data-mp="3nflgvd7sp7yn" />
              </div>
              <div data-id="element-750" data-mp="3hs03ko80bqaz">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-751" data-mp="3hsi8084tpatz">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Sibling, Friend" {...register(`financialPOA.alternate.${index}.relationship`)} data-id="element-752" data-mp="3dp3fwj3m1406" />
              </div>
              <div data-id="element-753" data-mp="b8gbjburt7n">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-754" data-mp="ctah7u99a4z">
                  Phone Number
                </label>
                <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register(`financialPOA.alternate.${index}.phone`)} data-id="element-755" data-mp="ebt0aiti7v2q" />
              </div>
            </div>
            <div className="mt-4" data-id="element-756" data-mp="3dm868g5a2nn5">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-757" data-mp="3dnaushf4odzw">
                Address
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter alternate attorney's address" {...register(`financialPOA.alternate.${index}.address`)} data-id="element-758" data-mp="38lty6y3ofdp4" />
            </div>
          </div>)}

        {/* Joint or Independent for alternates - only show if multiple alternate attorneys */}
        {alternateAttorneys.length > 1 && <div className="p-4 bg-amber-50 rounded-md border border-amber-200" data-id="element-759" data-mp="2fz9800yxt7n5">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-760" data-mp="2g1lw6vvage8n">
              Should your alternate attorneys act jointly or independently?
            </label>
            <div className="space-y-2" data-id="element-761" data-mp="10h35byecocbo">
              <label className="flex items-start" data-id="element-762" data-mp="10dyvoli48odm">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="jointly" {...register('financialPOA.alternateActing')} data-id="element-763" data-mp="15emh8rnksd0g" />
                <span className="ml-2 block" data-id="element-764" data-mp="1f7k419zloo4v">
                  <span className="font-medium" data-id="element-765" data-mp="1j5rly85svvhn">Jointly</span>
                  <span className="text-sm text-slate-600 block" data-id="element-766" data-mp="1o5w402mcwy9z">
                    All attorneys must agree and act together on all decisions.
                  </span>
                </span>
              </label>
              <label className="flex items-start" data-id="element-767" data-mp="3pxipxpre62zl">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="independently" {...register('financialPOA.alternateActing')} data-id="element-768" data-mp="3pz3hd6iet5t8" />
                <span className="ml-2 block" data-id="element-769" data-mp="3iuc74zwblkqp">
                  <span className="font-medium" data-id="element-770" data-mp="3ivn86rydsee4">
                    Independently (Jointly and Severally)
                  </span>
                  <span className="text-sm text-slate-600 block" data-id="element-771" data-mp="m38nnqozkor">
                    Any one attorney can act alone without the others.
                  </span>
                </span>
              </label>
            </div>
          </div>}
      </div>

      {/* When POA Takes Effect */}
      <div className="space-y-4" data-id="element-772" data-mp="5lptai8uo37l">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-773" data-mp="jf71x7zzzviu">
          When Should the Power of Attorney Take Effect?
        </h3>

        <div data-id="element-774" data-mp="ei6w8y728us9">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-775" data-mp="td4s411f42e3">
            Do you want the POA to be effective immediately or only upon
            incapacity?
          </label>
          <div className="space-y-3" data-id="element-776" data-mp="oc77ziwuky9y">
            <label className="flex items-start p-3 border border-slate-200 rounded-md hover:bg-slate-50" data-id="element-777" data-mp="17zk72ute90m6">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="uponIncapacity" {...register('financialPOA.effectiveDate')} data-id="element-778" data-mp="1c1ow1g8wd92h" />
              <span className="ml-3 block" data-id="element-779" data-mp="12yw73jn6t9ft">
                <span className="font-medium" data-id="element-780" data-mp="oc2x8twfsvv0">
                  Upon incapacity only (Standard/Recommended)
                </span>
                <span className="text-sm text-slate-600 block mt-1" data-id="element-781" data-mp="t3cp815gkba2">
                  The POA will only take effect upon a medical professional
                  adjudging in writing that you are incapable of managing your
                  own affairs. This is the standard approach.
                </span>
              </span>
            </label>
            <label className="flex items-start p-3 border border-slate-200 rounded-md hover:bg-slate-50" data-id="element-782" data-mp="ac1zvofds6ka">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="immediately" {...register('financialPOA.effectiveDate')} data-id="element-783" data-mp="1dmz97i1mvyde" />
              <span className="ml-3 block" data-id="element-784" data-mp="13w4d7lyl5ker">
                <span className="font-medium" data-id="element-785" data-mp="13v30ld1x8pux">Effective immediately</span>
                <span className="text-sm text-slate-600 block mt-1" data-id="element-786" data-mp="yxjoojsp4p65">
                  The POA will be effective immediately upon signing. Your
                  attorney can act on your behalf right away, even while you are
                  capable.
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>;
};
export default FinancialPOA;